import 'slick-carousel';

$('.single-item').slick({
    dots: true,
    arrows: false,
    fade: true,
    rtl: true

});


$('.our-heritage-gallery').slick({
    dots: true,
    arrows: false,
    fade: true,
    rtl: true
});



$('.other-articles').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: true,
    responsive: [{
            breakpoint: 1100,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true,
                slidesToScroll: 1
            }
        }
    ]
});